import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';
import { Separator, SwitchButton, Text } from 'trpc-react-native-ui';
import { ConfirmationModal } from '../../components/common';
import OrderSummary from '../../components/order/OrderSummary';
import SubscriptionDetails from '../../components/subscription/SubscriptionDetails';
import I18n from '../../lib/i18n';
import { formatDaysLeft } from '../../lib/date-utils';

import RtlAwareStyleSheet from '../../lib/rtl-aware-stylesheet';

function getStyles() {
  return RtlAwareStyleSheet.create({
    container: {
      backgroundColor: 'white',
    },
    scrollableContainer: {
      marginHorizontal: 10,
      marginVertical: 20,
    },
    renewalDateContainer: {
      padding: 20,
    },
    renewalDateText: {
      textAlign: 'center',
      marginBottom: 20,
    },
  });
}

class ChangePlanConfirmation extends Component {
  componentDidMount() {
    if (this.props.updateChangePlanDate) {
      this.props.updateChangePlanDate(this.props.nextRenewalDate);
    }
  }

  render() {
    const props = this.props;
    const styles = getStyles();
    const formatedDaysLeft = formatDaysLeft(props.daysLeft);
    return (
      <View style={styles.container}>
        <OrderSummary label={I18n.t('yourNewPlan')} totalPrice={props.price} periodicity={props.periodicity} />
        <Separator />
        <ScrollView style={styles.scrollableContainer}>
          <SubscriptionDetails options={props.offer.options} planCharacteristics={props.offer.plan.characteristics} />
        </ScrollView>
        <Separator />
        {props.allowChangePlanDate ? (
          <View style={styles.renewalDateContainer}>
            <Text style={styles.renewalDateText}>{I18n.t('changePlanDateTitle')}</Text>
            <SwitchButton
              variant="big"
              defaultIndex={props.changePlanNow ? 1 : 0}
              buttons={[
                {
                  label: I18n.t('changePlanDateLater', { date: formatedDaysLeft }),
                  callback: () => props.updateChangePlanDate(props.nextRenewalDate),
                },
                {
                  label: I18n.t('changePlanDateNow'),
                  callback: () => props.updateChangePlanDate(null),
                },
              ]}
            />
          </View>
        ) : null}
        <ConfirmationModal
          onConfirm={props.changePlan}
          openModalText={props.confirmButtonText}
          confirmContent={
            I18n.has(props.confirmModalContent) ? I18n.t(props.confirmModalContent) : props.confirmModalContent
          }
          title={I18n.t('confirmOrder')}
        />
      </View>
    );
  }
}

ChangePlanConfirmation.propTypes = {
  price: PropTypes.number.isRequired,
  periodicity: PropTypes.object.isRequired,
  changePlanNow: PropTypes.bool,
  nextRenewalDate: PropTypes.number.isRequired,
  daysLeft: PropTypes.number.isRequired,
  updateChangePlanDate: PropTypes.func,
  changePlan: PropTypes.func,
  offer: PropTypes.object,
  allowChangePlanDate: PropTypes.bool,
  confirmButtonText: PropTypes.string.isRequired,
  confirmModalContent: PropTypes.string.isRequired,
  navigation: PropTypes.func,
};

export default ChangePlanConfirmation;
